import { AlertTriangleIcon, CheckCircle2Icon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useDegradedMode, useSetDegradedMode } from '@/lib/admin-queries';
import { strings } from '@/i18n/strings';
import { formatTashkent } from '@/lib/time';

/**
 * Cheklangan rejim banneri — soliq sayti javob bermay qolganda.
 *
 * Ranglar `warning` mavzu o'zgaruvchilaridan olinadi, Tailwind ning `amber` shkalasidan emas.
 * Ilgari teskarisi edi va natijada panelda ikkita sariq bor edi: bu bannerda bittasi,
 * yorliqlar va ogohlantirishlarda boshqasi — bir xil ma'noda, ammo boshqa rangda. Matn rangi
 * mavzuga qarab almashadi (yorug'da to'q jigarrang, qorong'ida och sariq): `--warning` ning
 * o'zi ikkala fonda ham o'qilmasdi.
 *
 * Belgi sekin nafas oladi. Bu paneldagi yagona to'xtovsiz harakat va u shu yerda o'rinli:
 * banner faqat haqiqiy nosozlikda ko'rinadi, ya'ni harakat "hali ham shu holatda" degan
 * ma'noni beradi — operator ekranga har qaraganda uni qaytadan payqaydi.
 */
export function DegradedModeBanner() {
  const { data: status } = useDegradedMode();
  const setDegraded = useSetDegradedMode();

  if (!status?.active) return null;

  const handleReset = () => {
    setDegraded.mutate({ active: false });
  };

  return (
    <div
      role="alert"
      className="border-warning/45 bg-warning/12 text-warning-foreground dark:text-warning motion-rise mb-6 rounded-lg border p-4"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <AlertTriangleIcon className="motion-breathe mt-0.5 size-5 shrink-0" aria-hidden="true" />
          <div className="space-y-1">
            <div className="flex flex-wrap items-center gap-2">
              <h3 className="text-sm leading-tight font-semibold">
                {strings.degradedMode.bannerTitle}
              </h3>
              <Badge
                variant="outline"
                className="border-warning/50 bg-warning/20 text-[11px] text-current"
              >
                {status.automatic ? strings.degradedMode.automatic : strings.degradedMode.manual}
              </Badge>
            </div>
            <p className="text-xs opacity-85">{strings.degradedMode.bannerDescription}</p>
            {status.reason ? (
              <p className="font-mono text-xs opacity-90">
                <span className="font-sans font-medium">{strings.degradedMode.reasonPrefix}</span>
                {status.reason}
              </p>
            ) : null}
            {status.since ? (
              <p className="tabular text-[11px] opacity-75">{formatTashkent(status.since)}</p>
            ) : null}
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2 self-end sm:self-center">
          <Button
            size="sm"
            variant="outline"
            loading={setDegraded.isPending}
            onClick={handleReset}
            className="border-warning/50 bg-background hover:bg-warning/20 text-current"
          >
            {setDegraded.isPending ? (
              strings.degradedMode.resetting
            ) : (
              <>
                <CheckCircle2Icon aria-hidden="true" />
                {strings.degradedMode.resetButton}
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
